import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=68f3bfdf&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=68f3bfdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../hotel-wc-product/hotel-wc/sources/client/hotel-wc-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f3bfdf",
  null
  
)

export default component.exports